import { Accordion, AccordionProps, Skeleton, Stack } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import { FC } from 'react';

import { EpisodeBar } from '@/components/ui/features/originals/EpisodesSection/components/EpisodeBar';
import { useEpisodeContext } from '@/components/ui/features/originals/EpisodesSection/EpisodeSection.context';
import { SlugIdParam, useQueryParams } from '@/hooks/useQueryParams';
import { queryEpisodesForSeries } from '@/queries/originals-episodes';

function EpisodeListFallback() {
  return (
    <Stack>
      <Skeleton height="64px" />
      <Skeleton height="64px" />
      <Skeleton height="64px" />
    </Stack>
  );
}

export const EpisodeList: FC<AccordionProps> = (props) => {
  const { id: seriesId } = useQueryParams<{ id: string }>({
    id: SlugIdParam,
  });

  const { selectedEpisodeId, setSelectedEpisodeId } = useEpisodeContext();
  const { data: episodes = [], error } = useResources(queryEpisodesForSeries(seriesId));

  const selectedEpisode = episodes?.find((e) => e.id === selectedEpisodeId) || episodes[0];

  if (error) throw error;

  if (!episodes) {
    return <EpisodeListFallback />;
  }

  return (
    <Accordion allowToggle {...props}>
      {episodes?.map((episode) => (
        <EpisodeBar
          key={episode.slug}
          isPlaying={episode.id === selectedEpisode.id}
          onPlayClick={setSelectedEpisodeId}
          episode={episode}
          mb="1rem"
        />
      ))}
    </Accordion>
  );
};
